import "core-js/modules/es6.object.assign";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.find";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    for (var _iterator = _createForOfIteratorHelperLoose(__getOwnPropSymbols(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
  }

  return a;
};

var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};

var findDataByCode = function findDataByCode(_ref) {
  var filterOptions = _ref.filterOptions,
      filterType = _ref.filterType,
      code = _ref.code;
  var result = void 0;
  filterOptions.forEach(function (option) {
    if (option.subItems && option.subItems.length !== 0) {
      var founded = option.subItems.find(function (e) {
        return e.code === code;
      });

      if (founded) {
        result = {
          filterType: filterType,
          option: founded
        };
      }
    }

    if (option.code === code) {
      result = {
        filterType: filterType,
        option: option
      };
    }
  });
  return result;
};

var updateAppliedFilters = function updateAppliedFilters(_ref2) {
  var appliedFilters = _ref2.appliedFilters,
      setAppliedFilters = _ref2.setAppliedFilters,
      result = _ref2.result;
  var appliedFiltersKeys = Object.keys(appliedFilters);

  if (appliedFiltersKeys.length !== 0) {
    var newAppliedFilters = {};

    if (appliedFiltersKeys.find(function (e) {
      return e === result.filterType;
    })) {
      appliedFiltersKeys.forEach(function (filterType) {
        if (filterType === result.filterType) {
          var presentObject = Object.keys(appliedFilters[filterType]).find(function (e) {
            return e === result.option.code;
          });

          if (!presentObject) {
            var _spreadProps, _Object$assign;

            Object.assign(newAppliedFilters, (_Object$assign = {}, _Object$assign[filterType] = __spreadProps(__spreadValues({}, appliedFilters[filterType]), (_spreadProps = {}, _spreadProps[result.option.code] = {
              name: result.option.name || "",
              code: result.option.code || ""
            }, _spreadProps)), _Object$assign));
          }
        } else {
          var _Object$assign2;

          Object.assign(newAppliedFilters, (_Object$assign2 = {}, _Object$assign2[filterType] = __spreadValues({}, appliedFilters[filterType]), _Object$assign2));
        }
      });
    } else {
      var _result$filterType, _spreadProps2;

      Object.assign(newAppliedFilters, __spreadProps(__spreadValues({}, appliedFilters), (_spreadProps2 = {}, _spreadProps2[result.filterType] = (_result$filterType = {}, _result$filterType[result.option.code] = {
        name: result.option.name,
        code: result.option.code
      }, _result$filterType), _spreadProps2)));
    }

    setAppliedFilters(newAppliedFilters);
  } else {
    var _result$filterType2, _setAppliedFilters;

    setAppliedFilters((_setAppliedFilters = {}, _setAppliedFilters[result.filterType] = (_result$filterType2 = {}, _result$filterType2[result.option.code] = {
      name: result.option.name,
      code: result.option.code
    }, _result$filterType2), _setAppliedFilters));
  }
};

export { findDataByCode, updateAppliedFilters };